import useTypedContext from "hooks/useTypedContext";
import useHasModuleWriteAccess from "shared/Module/access/useHasModuleWriteAccess";
import useHasStackWriteAccess from "shared/Stack/access/useHasStackWriteAccess";
import { Module, Stack } from "types/generated";
import { AccountContext } from "views/AccountWrapper";
import { RunContext } from "components/Run/Context";
import useTypedFlags from "hooks/useTypedFlags";

const isStack = (stack: Stack | Module): stack is Stack => (stack as Stack).__typename === "Stack";

const useRunSummary = () => {
  const { runSummarizationAssistant } = useTypedFlags();

  const { stack: stackOrModule } = useTypedContext(RunContext);
  const { spaceliftIntelligenceTermsAccepted, spaceliftIntelligenceEnabled } =
    useTypedContext(AccountContext);

  const isSummarizationAssistantMode = runSummarizationAssistant && spaceliftIntelligenceEnabled;

  const hasStackWriteAccess = useHasStackWriteAccess();
  const hasModuleWriteAccess = useHasModuleWriteAccess();

  const canTriggerSummary = isStack(stackOrModule)
    ? hasStackWriteAccess(stackOrModule)
    : hasModuleWriteAccess(stackOrModule);

  const showSummarizerTrigger = isSummarizationAssistantMode;

  return {
    spaceliftIntelligenceTermsAccepted,
    canTriggerSummary,
    showSummarizerTrigger,
  };
};

export default useRunSummary;
